import { render, staticRenderFns } from "./RewardsLeaderboardView.vue?vue&type=template&id=6efdaced&scoped=true&"
import script from "./RewardsLeaderboardView.vue?vue&type=script&lang=js&"
export * from "./RewardsLeaderboardView.vue?vue&type=script&lang=js&"
import style0 from "./RewardsLeaderboardView.vue?vue&type=style&index=0&id=6efdaced&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efdaced",
  null
  
)

export default component.exports